export default __webpack_public_path__ + "static/media/Ativo-2.f32cfa55.svg";